import React from "react"
import autobind from "class-autobind"
import FinddDatePicker from "../../../../../../components/common/FinddDatePicker"
import { TextField, FontIcon } from "material-ui"
import moment from "moment"
import { blueGrey500 } from "material-ui/styles/colors"

interface IProps {
    field
    value
    onChange(key, value): void
}

interface IState {
}

export default class FormDateField extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
        }
        autobind(this)
    }
    private FinddDatePicker

    render() {
        const field = this.props.field
        const value = this.props.value ? this.props.value : moment().format("MM/DD/YYYY")
        const onChange = this.props.onChange

        return (
            <span>
                <span
                    style={{ marginTop: -7, cursor: "pointer" }}
                    data-intercom-target={"CalendarFilter-Btn-OpenDatePicker"}
                    onClick={() => this.FinddDatePicker.DatePicker.openDialog()}                     
                >
                    <span>
                        <FontIcon className={"fa fa-calendar"} /> 
                        <TextField
                            style={{marginLeft: 10}}
                            floatingLabelText={field.label}
                            value={value}
                        />    
                    </span>
                </span>

                <FinddDatePicker
                    ref={(elem) => (this.FinddDatePicker = elem)}
                    id={"day-select-field"}
                    textFieldStyle={{ display: "none" }}
                    value={moment(value).toDate()}
                    onChange={(_, date: Date) => onChange(field.name, moment(date).format("MM/DD/YYYY"))}
                    cancelLabel={<span style={{ color: blueGrey500 }}>Cancel</span>}
                    firstDayOfWeek={0}
                    //maxDate={this.props.limitMaxDay && moment(this.props.limitMaxDay).toDate()}
                />        
            </span>
        )
    }
}